/*
 * @Author: DQL
 * @Date: 2020-03-05 17:31:01
 * @LastEditors: DQL
 * @LastEditTime: 2022-04-27 16:40:01
 * @Description: file content
 */
const config = {
  // 系统信息
  app: {
    code: 'kestrel-portal',
    name: '鸿蒙门户'
  },
  // 授权信息
  copyright: 'Copyright © 2022 广州鸿蒙信息科技有限公司',

  checkVersionIntervalTime: ['09:00'], // 定时检测更新（检测版本，通知更新版本）24小时制格式，如：09:09，00:00，示例数据：['10:20', '11:28', '12:14', '11:32']

  isAutoRefreshVersion: true, // 是否自动检测刷新页面

  /* =============================================
     右侧导航菜单配置start
    *
  */

  isCollapseMenu: false, // 导航菜单是否默认收起状态

  hasMenuSearch: true, // 导航菜单搜索功能是否开启

  /* 右侧导航菜单配置end */

  /* =============================================
     导航页签navTab配置start
    *
   */
  isFirstNavtab: true, // 配置导航页签navTab是否设定首页

  // 首页页签配置
  firstNavtab: {
    title: '首页', // navTab显示标题
    isCache: true, // 页面缓存
    hasClose: false, // 是否可关闭（默认首页不可关闭）
    routeName: 'main',
    routePath: '/main'
  },

  openNavtabLimit: 20, // 打开的页签数量限制
  /* 导航页签navTab配置 End */

  /* =============================================
     请求服务配置 Start
    *
   */

  // 服务端认证token名称
  serverHeaderTokenName: 'hmportal-auth-token',
  // 浏览器本地token名称
  localTokenName: 'hmportal-auth-token',

  // 公共ctx
  commontCtx: process.env.VUE_APP_COMMON_CTX,
  authCtx: process.env.VUE_APP_CTX_AUTHAPI,

  // 服务ctx
  ctx: {
    hmfileApi: process.env.VUE_APP_CTX_HMFILEAPI, // 文件服务
    workflowCtx: process.env.VUE_APP_CTX_WORKFLOW, // 工作流ctx
    logApi: process.env.VUE_APP_CTX_LOGAPI, // log服务
    kqxtApi: process.env.VUE_APP_CTX_KQXTAPI // 考勤系统服务
  },

  // 文件服务预加载api
  prepareUrl: process.env.VUE_APP_CTX_HMFILEAPI + '/file/initupload',

  // 文件服务上传api
  uploadUrl: process.env.VUE_APP_CTX_HMFILEAPI + '/file/upload',

  // 文件服务器下载地址
  downloadUrl: process.env.VUE_APP_CTX_HMFILEAPI + '/file/download/'

  /* 请求服务配置 End */

};

export default config;
